import {
  alpha,
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme
} from '@mui/material';

export const tableContainer: {
  defaultProps?: ComponentsProps['MuiTableContainer'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTableContainer'];
  variants?: ComponentsVariants<Theme>['MuiTableContainer'];
} = {
  defaultProps: {},
  styleOverrides: {
    root({ theme }) {
      return {
        border: 'none',
        // Un tableau a une largeur minimale que ses colonnes imposent. Sur un
        // téléphone il pousse la page entière et fait apparaître un ascenseur
        // horizontal au niveau du document. Le confiner ici garde la page
        // fixe : c'est le tableau qui défile, pas l'écran.
        [theme.breakpoints.down('md')]: {
          maxWidth: '100%',
          overflowX: 'auto'
        }
      };
    }
  }
};

export const tableRow: {
  defaultProps?: ComponentsProps['MuiTableRow'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiTableRow'];
  variants?: ComponentsVariants<Theme>['MuiTableRow'];
} = {
  defaultProps: {},
  styleOverrides: {
    root({ theme }) {
      return {
        '.MuiTableCell-root': {
          border: 'none !important'
        },

        '&:nth-of-type(odd)': {
          background: alpha('#ffffff', 0.05)
        },
        // hide last border
        '&:last-child td, &:last-child th': {
          border: 0
        },
        '&.MuiTableHead-root, .MuiTableCell-head': {
          backgroundColor: theme.palette.grey[800],
          borderBottom: `none`
        },
        '.MuiTableCell-head:last-child': {
          borderRadius: '0 8px 0 0'
        },
        '.MuiTableCell-head:first-child': {
          borderRadius: '8px 0 0 0'
        }
      };
    }
  }
};
